export type AgentDomain = 'appraisal' | 'legal' | 'financial';

export interface AgentPersona {
  domain: AgentDomain;
  name: string;
  tagline: string;
  /** Path under /public, or null → render an initial-letter placeholder. */
  avatar: string | null;
  /** true → `avatar` is a 2×2 gendered sprite (crop the male cell). */
  sprite?: boolean;
  gender?: 'male' | 'female';
}

export const PERSONA_BY_DOMAIN: Record<AgentDomain, AgentPersona> = {
  appraisal: { domain: 'appraisal', name: 'יוני',  tagline: 'שמאי מקרקעין',        avatar: '/avatars/he-blue.jpeg', sprite: true, gender: 'male' },
  legal:     { domain: 'legal',     name: 'דנה',   tagline: 'יועצת משפטית',         avatar: '/avatars/dana.webp' },
  financial: { domain: 'financial', name: 'גלית',  tagline: 'יועצת פיננסית בכירה',  avatar: '/avatars/galit.webp' },
};

export const DOMAINS: AgentDomain[] = ['appraisal', 'legal', 'financial'];
export const DEFAULT_DOMAIN: AgentDomain = 'financial';

export const DOMAIN_LABELS: Record<AgentDomain, string> = {
  appraisal: 'שמאות נדל"ן', legal: 'משפטי', financial: 'פיננסי',
};

export function personaForDomain(domain: string | null | undefined): AgentPersona {
  const d = (domain ?? '') as AgentDomain;
  return PERSONA_BY_DOMAIN[d] ?? PERSONA_BY_DOMAIN[DEFAULT_DOMAIN];
}
